import { GetUpsellingDataQuery } from '@notino/shared/definitions/types';

import { ProductEventWither } from './prepareProductInfo';
import { TrackedProduct } from './useTrackDynamicList';

export type VpProduct = NonNullable<
  GetUpsellingDataQuery['vpProductByIds'][number]
>;

/**
 * Builds the `view_item_list` payload for a single product impression from a vp
 * product. Shared by product lists that report impressions through
 * `useTrackDynamicList`. `position` is 1-based.
 *
 * `withVpProduct` is cast (as the rest of the tracking code is) because it
 * expects a non-null `name`, while the GraphQL product allows `name: null`.
 */
export const buildProductImpression = (
  product: VpProduct,
  position: number
): TrackedProduct =>
  ProductEventWither()
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .withVpProduct({ ...product, reviewOverview: null } as any)
    .withDiscountPrices(product.attributes, {
      shouldSendOnlyDiscountPrice: true,
    })
    .withAdditionalData({ list_position: position, id: product.id })
    .forceBuild() as TrackedProduct;
